export default __webpack_public_path__ + "static/media/used-car-selected.916bd855.svg";